<template>
    <ul class="uk-list"  v-if="creditCard">
        <li>{{ creditCard.description }}</li>
        <li>{{ creditCard.token }}</li>
    </ul>
</template>

<script>
  export default {
    computed: {
      creditCard() {
        return this.$store.state.checkout.payment.handlerData ? this.$store.state.checkout.payment.handlerData.creditCard : null;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/payment/CreditCardSummary.vue